import CourseName from './course-name.jsx'
import { useTranslation } from 'react-i18next'

const MessageCreatorInfo = ({ message }) => {
  const i18n = useTranslation('translation', { keyPrefix: 'pages.modeBup.inbox' })
  if (!message) return <span>{i18n.t('no-message')}</span>
  const { anonymus: isAnonymous } = message
  const enrollment = message.Enrollment

  const userName = isAnonymous ? i18n.t('anonymousname') : enrollment?.user?.name || ''
  const roleName = enrollment?.role?.name || ''

  return (
    <div>
      <span>
        {userName} - {roleName} - <CourseName message={message} />
      </span>
    </div>
  )
}

export default MessageCreatorInfo
